export default {
    edit_scheduled_action_title: "Editar acción programada",
    edit_scheduled_action_success_message: "Se ha editado la acción programada",
    edit_scheduled_action_error_message: "La acción programada no se ha editado debido a un error",
    edit_scheduled_status: "Estado",
    edit_scheduled_scheduled_at: "Programado en",
    edit_scheduled_already_scheduled_action: "La entidad ya tiene una acción programada para esa fecha",
}